var _filter, _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHockey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1j:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 17.469,
    width: 20,
    x: 2,
    y: 4
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2978_44175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2978_44175",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1j:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3,
    x2: 17.3683,
    y1: 6.21844,
    y2: 22.3909
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#:r1j:-filter)",
    className: "Ui-outlineFilter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m17.4862 5c-.2559 0-.4859.1575-.5781.39644l-2.4675 6.37616c-.2166.542-.6236.9838-1.1457 1.2442-.3291.1646-.6967.2511-1.0642.2511h-6.43428c-.94048 0-1.77176.5992-2.06941 1.4913l-.61283 1.8377c-.22447.6734-.11469 1.3902.30036 1.9661.41505.5758 1.05925.9059 1.76905.9059h7.75521c1.4717 0 2.9262-.8484 3.4711-2.0468l4.5474-11.57512c.0748-.19099.0503-.407-.0654-.5765-.1154-.16949-.3069-.27048-.5119-.27048zm-8.68135 1.20063c-1.87971 0-3.40406.55519-3.40406 1.24019 0 .611 1.21486 1.1179 2.81223 1.22.01736.00125.03431.00199.05167.00323.17652.01034.35579.01696.54016.01696 1.88015 0 3.40405-.55519 3.40405-1.24019s-1.5243-1.24019-3.40405-1.24019zm-3.51387 2.89701v.65643c0 1.22113 1.76768 1.86033 3.51387 1.86033 1.74615 0 3.51385-.6392 3.51385-1.86033v-.64594c-1.0219.62299-2.58608.81226-3.5526.81226-1.17777 0-2.56772-.2287-3.47512-.82275z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.4862 5c-.2559 0-.4859.1575-.5781.39644l-2.4675 6.37616c-.2166.542-.6236.9838-1.1457 1.2442-.3291.1646-.6967.2511-1.0642.2511h-6.43428c-.94048 0-1.77176.5992-2.06941 1.4913l-.61283 1.8377c-.22447.6734-.11469 1.3902.30036 1.9661.41505.5758 1.05925.9059 1.76905.9059h7.75521c1.4717 0 2.9262-.8484 3.4711-2.0468l4.5474-11.57512c.0748-.19099.0503-.407-.0654-.5765-.1154-.16949-.3069-.27048-.5119-.27048zm-8.68135 1.20063c-1.87971 0-3.40406.55519-3.40406 1.24019 0 .611 1.21486 1.1179 2.81223 1.22.01736.00125.03431.00199.05167.00323.17652.01034.35579.01696.54016.01696 1.88015 0 3.40405-.55519 3.40405-1.24019s-1.5243-1.24019-3.40405-1.24019zm-3.51387 2.89701v.65643c0 1.22113 1.76768 1.86033 3.51387 1.86033 1.74615 0 3.51385-.6392 3.51385-1.86033v-.64594c-1.0219.62299-2.58608.81226-3.5526.81226-1.17777 0-2.56772-.2287-3.47512-.82275z",
    fill: "url(#:r1j:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m8.17926 9.15969c.01187.00083.023.00147.03065.00191l.01916.00118-.00001.00005.00641.00037c.18377.01076.37305.01781.56938.01781.98277 0 1.89435-.14428 2.57825-.39343.3399-.12383.6501-.28311.8847-.48517.233-.20073.4411-.4902.4411-.86159 0-.37144-.2082-.66092-.4412-.86162-.2346-.20205-.5449-.36132-.8848-.48515-.6839-.24914-1.59547-.39342-2.57805-.39342-.98257 0-1.89417.14428-2.57807.39342-.3399.12383-.65015.2831-.88474.48515-.23303.2007-.44125.49018-.44125.86162 0 .33102.16669.59846.36618.79247.19809.19265.45964.34602.74386.4679.57059.24468 1.33286.40492 2.16843.4585zm0 0c-.00062-.00005-.00124-.00009-.00187-.00014l.03563-.49873-.0319.49899c-.00062-.00004-.00124-.00008-.00186-.00012zm4.89244 3.40971-.0004.0002c-.2595.1298-.5505.1983-.8406.1983h-6.43428c-1.15572 0-2.17799.7369-2.54371 1.8331l-.00002.0001-.61283 1.8376-.00002.0001c-.27537.8261-.13981 1.7105.36908 2.4165.50894.7062 1.304 1.1136 2.17467 1.1136h7.75521c1.6345 0 3.2874-.9345 3.9263-2.3399l.0054-.0119.0048-.0122 4.5473-11.57509.0002-.00044c.1352-.34494.091-.73473-.1179-1.04074-.2088-.30645-.5552-.48863-.9249-.48863h-2.8938c-.4622 0-.8777.28426-1.0445.71618 0 .0001-.0001.00019-.0001.00028l-2.4662 6.37294c-.1713.4269-.4921.7747-.9037.98zm-7.50686-3.89009-.77386-.50663v.92496.65643c0 .89583.65551 1.49333 1.38824 1.84003.745.3526 1.70139.5203 2.62563.5203s1.88065-.1677 2.62565-.5203c.7327-.3467 1.3882-.9442 1.3882-1.84003v-.64594-.8904l-.7602.46348c-.9029.55038-2.35408.73918-3.2924.73918-1.14088 0-2.41423-.22584-3.20126-.74108z",
    stroke: "#5800e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/hockey.bd2eeba5a730d9c76aaeb364c8e6e1a2.svg";
export { ForwardRef as ReactComponent };